import { useEffect, useState } from 'react';
import { get } from '../api.js';
import { PageTitle } from '../frame.js';
import { t } from '../i18n.js';

interface Device {
  id: string;
  name: string;
  systemName: string;
  profile: string;
  formatName: string | null;
}

export function AdminAutocuePage() {
  const [devices, setDevices] = useState<Device[]>([]);
  useEffect(() => {
    get<{ devices: Device[] }>('/api/autocue-devices').then((r) => setDevices(r.devices));
  }, []);
  return (
    <>
      <PageTitle title="Κατάλογος όλων των Autocue" hint="Οι συσκευές Autocue και η κωδικοποίηση του αρχείου κάθε μιας" />
      <div className="table-scroll">
        <table className="grid">
          <thead>
            <tr>
              <th>{t('department')}</th>
              <th>Όνομα</th>
              <th>System Name</th>
              <th>Format</th>
              <th>Encoding</th>
            </tr>
          </thead>
          <tbody>
            {devices.map((d) => (
              <tr key={d.id}>
                <td className="c">TV</td>
                <td>{d.name}</td>
                <td>{d.systemName}</td>
                <td>{d.formatName ?? ''}</td>
                <td className="c">{d.profile === 'utf8' ? 'UTF-8' : 'win-1253'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="tip">Η διαχείριση συσκευών (νέα τιμή, τροποποίηση) γίνεται προς το παρόν με το CLI/seed· η φόρμα θα προστεθεί με τη μετάπτωση των ρυθμίσεων από το HPress.</p>
    </>
  );
}

interface Health {
  worker: { playout: { adapter: string; online: boolean; lastEventAt: string | null; pending: number; failed: number; lagMs: number | null; voPlayer?: { id: string; name: string } | null } } | null;
}

export function AdminIntegrationsPage() {
  const [health, setHealth] = useState<Health | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const tick = () =>
      get<Health>('/api/integrations/health')
        .then(setHealth)
        .catch((e) => setError(String(e)));
    tick();
    const h = window.setInterval(tick, 5000);
    return () => window.clearInterval(h);
  }, []);
  const p = health?.worker?.playout;
  return (
    <>
      <PageTitle title="Playout / MOS" hint="Κατάσταση των διασυνδέσεων και της ουράς outbox" />
      {error && <div className="banner err">{error}</div>}
      <table className="card" style={{ maxWidth: 700 }}>
        <tbody>
          <tr>
            <th>Playout adapter</th>
            <td>{p ? `${p.adapter} · ${p.online ? 'online' : 'offline'}` : '—'}</td>
          </tr>
          <tr>
            <th>Player VO</th>
            <td>{p ? (p.voPlayer ? `${p.voPlayer.name} (${p.voPlayer.id}) · εκεί πάνε τα ΒΙΝΤΕΟ VO· τα ΒΙΝΤΕΟ ΜΕ ΗΧΟ στον player του δελτίου` : 'κανένας · όλα τα video στον player του δελτίου (PLAYOUT_VO_PLAYER)') : '—'}</td>
          </tr>
          <tr>
            <th>Outbox pending / failed</th>
            <td>{p ? `${p.pending} / ${p.failed}` : '—'}</td>
          </tr>
          <tr>
            <th>Lag</th>
            <td>{p?.lagMs !== null && p?.lagMs !== undefined ? `${p.lagMs} ms` : '—'}</td>
          </tr>
          <tr>
            <th>Last event</th>
            <td>{p?.lastEventAt ?? '—'}</td>
          </tr>
          <tr>
            <th>MOS gateway</th>
            <td className="muted">Δεν είναι ακόμη ρυθμισμένος για την εγκατάσταση της Alpha (βλ. docs/open-questions.md Q11).</td>
          </tr>
        </tbody>
      </table>
    </>
  );
}
